import { get } from 'lodash';
import { createSelector } from 'reselect';
import { RIGHT_PANE_VARIANTS } from '../../right-pane/constants';

export const rightPaneAttributesSelector = state => get( state, 'rightPane.attributes', {} );
export const rightPaneTitleSelector = state => get( state, 'rightPane.title', '' );
export const rightPaneSubtitleSelector = state => get( state, 'rightPane.subtitle', '' );
export const rightPaneVariantSelector = state => get( state, 'rightPane.variant', RIGHT_PANE_VARIANTS['standard'] );

export const activeRightPaneSelector = state => get( state, 'rightPane.activeRightPane', null );
export const isActiveRightPaneSelector = ( state, paneType ) => get( state, 'rightPane.activeRightPane', null ) === paneType;

export const rightPaneIsOpenSelector = createSelector(
    activeRightPaneSelector,
    ( activeRightPane ) => activeRightPane != null );
